import * as React from "react";
import { useCallback } from "react";
import notify from "devextreme/ui/notify";

const useNotification = () => {

    const notifyHandler = useCallback((type: "error" | "success" | "info" | "warning", message: string, displayTime: number = 15000) => {
        notify({
            closeOnClick: true,
            closeOnOutsideClick: true,
            message
        }, type, displayTime);
    }, [])

    return notifyHandler;
}
export default useNotification;